import SectionPanel from "pages/analytics/components/SectionPanel";
import {
  EmptyMessage,
  ErrorBanner,
  TableSkeleton,
} from "pages/analytics/components/AnalyticsStates";
import { formatNumber, formatPercent } from "pages/analytics/components/analyticsFormatters";
import { isCustomRangeIncomplete } from "utils/analyticsQueryParams";

export default function UtmBreakdownTable({
  title,
  columnLabel,
  rows,
  isLoading,
  error,
  filters,
  emptyMessage,
  className = "",
}) {
  return (
    <SectionPanel title={title} className={className}>
      {error && (
        <div className="mb-4">
          <ErrorBanner message={error} />
        </div>
      )}

      {isLoading ? (
        <TableSkeleton rows={6} cols={3} />
      ) : isCustomRangeIncomplete(filters) ? (
        <EmptyMessage message={`Select start and end dates to view ${title.toLowerCase()}.`} />
      ) : error ? (
        <EmptyMessage message={`${title} unavailable due to a loading error.`} />
      ) : rows.length === 0 ? (
        <EmptyMessage message={emptyMessage} />
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                  {columnLabel}
                </th>
                <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">
                  Contacts
                </th>
                <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase">
                  Contact Share
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {rows.map((row) => (
                <tr key={row.value || "(not set)"} className="hover:bg-gray-50">
                  <td className="px-3 py-2.5 text-sm text-gray-900">
                    {row.value || "(not set)"}
                  </td>
                  <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
                    {formatNumber(row.count)}
                  </td>
                  <td className="px-3 py-2.5 text-sm text-gray-600 text-right">
                    {formatPercent(row.percent)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SectionPanel>
  );
}
